import { Figure as e } from "./components/Figure.es.js";
import { FigureImage as t } from "./components/FigureImage.es.js";
import { FigureText as n } from "./components/FigureText.es.js";
import { FigureByline as r } from "./components/FigureByline.es.js";
import "./components/index.es.js";
import { consume as i } from "./lib/consume.es.js";
import { consumes as a } from "./lib/consumes.es.js";
import { normalizeImage as o } from "./lib/normalizeImage.es.js";
import { actionHandler as s } from "./lib/actionHandler.es.js";
import { ImageIcon as c } from "lucide-react";
import { jsx as l } from "react/jsx-runtime";
// lib/Image/index.tsx
var u = (u) => ({
	class: "block",
	name: "core/image",
	options: u,
	consumer: {
		consumes: u?.consumes ?? a,
		consume: u?.consume ?? i
	},
	actions: [{
		name: "insert-image",
		title: "Image",
		tool: () => /* @__PURE__ */ l(c, { style: {
			width: "1em",
			height: "1em"
		} }),
		handler: s,
		visibility: u?.visibility ?? (() => [
			!0,
			!0,
			!1
		])
	}],
	componentEntry: {
		class: "block",
		component: e,
		constraints: { normalizeNode: o },
		children: [
			{
				type: "image",
				class: "void",
				component: t,
				constraints: {
					min: 1,
					max: 1
				}
			},
			{
				type: "text",
				class: "text",
				component: n,
				constraints: {
					allowBreak: !1,
					min: 1,
					max: 1
				}
			},
			{
				type: "byline",
				class: "text",
				component: r,
				constraints: {
					allowBreak: !1,
					min: 1,
					max: 1
				}
			}
		]
	}
});
export { u as Image };
